export default "__VITE_ASSET__CjGjRlPC__"